import BancosPage from "@/Pages/Bancos/index.vue";
import temPermissao from "./guards/temPermissao";

export default [
  {
    path: "/bancos/:franquiaId",
    name: "bancos",
    component: BancosPage,
    beforeEnter: (to, from, next) => {
      if (!temPermissao("financeiro.baixarParcela", to, from, next)) return;
      next();
    },
  },
];
